import { useMemo } from "react";
import { useCsAttribute } from "./useCsAttribute";
/**
 * Provides helper functions for substructure attributes
 * - requires {@linkcode CsAttributeController}
 * @category Hook
 * @category CsAttribute
 * @export
 * @returns {SubstructureMeta}
 */
export function useSubstructureMeta() {
    var _a, _b, _c, _d, _e;
    const attribute = useCsAttribute();
    const substructures = (_a = attribute.configurations) !== null && _a !== void 0 ? _a : [];
    const minInstances = Number((_b = attribute.cardinalityMin) !== null && _b !== void 0 ? _b : 0);
    const maxInstances = Number((_c = attribute.cardinalityMax) !== null && _c !== void 0 ? _c : Infinity);
    const numInstances = (_e = (_d = attribute.configurations) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0;
    const canDelete = substructures.length > minInstances;
    const canAdd = substructures.length < maxInstances;
    const canCopy = canAdd;
    const isSingleInstance = maxInstances === 1;
    const attributePath = attribute.path;
    return useMemo(() => ({
        minInstances,
        maxInstances,
        numInstances,
        canAdd,
        canCopy,
        canDelete,
        isSingleInstance,
        attributePath,
    }), [
        minInstances,
        maxInstances,
        numInstances,
        canAdd,
        canCopy,
        canDelete,
        isSingleInstance,
        attributePath,
    ]);
}
//# sourceMappingURL=useSubstructureMeta.js.map